import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';

import Modal from '@components/Modal/Modal';
import { userDataSelector } from '@store/features/auth/user/selectors';

import { IUserProfileModalAdminProps } from './UserProfileModalAdmin.interface';

import './style.scss';

const handleChangePassword = (): void => {
  if (process.env.REACT_APP_FORGOT_PASS_URL) {
    window.location.href = process.env.REACT_APP_FORGOT_PASS_URL;
  }
};

const UserProfileModalAdmin: FC<IUserProfileModalAdminProps> = ({ open, onClose }) => {
  const user = useSelector(userDataSelector);

  const { t } = useTranslation();

  return (
    <Modal
      title={t('userProfile.title')}
      open={open}
      onClose={onClose}
      onLeftAction={onClose}
      leftActionTitle={t('common.close')}
      className="user-profile-modal-admin"
    >
      <span className="user-profile-modal-admin__email">{user?.email}</span>
      <span className="user-profile-modal-admin__admin">
        {t('userProfile.admin')} <Box component="img" src="/images/img-admin.svg" />
      </span>
      <Button variant="text" onClick={handleChangePassword}>
        {t('userProfile.changePassword')}
      </Button>
    </Modal>
  );
};

export default UserProfileModalAdmin;
